<section class="flex-column gap-24" [formGroup]="qualityLinkedSettingsForm">
  <div class="flex-column gap-16">
    <h3 class="font-weight-semibold">
      {{ 'PRODUCTION_ORDER.CUSTOM_SETTINGS.QUALITY_LINKED_SETTINGS.TITLE' | bmsTranslate }}
    </h3>
    <div class="full-width">
      <div class="flex-column flex-start-start gap-4 mb-16">
        <mat-label class="b2">{{ 'PRODUCTION_ORDER.CUSTOM_SETTINGS.QUALITY_LINKED_SETTINGS.FILL_PATH_DIFFERENCE' | bmsTranslate }}</mat-label>
        <div vdwCheckboxButtonToggle class="checkbox-toggle-buttons flex-row">
          <mat-checkbox formControlName="repeatLastDesignToEndOfPath">{{ 'TEXTILE_DATA.MACHINE_QUALITY.JUTE_CONDITIONS.REPEAT_LAST_DESIGN' | bmsTranslate }}</mat-checkbox>
          <mat-checkbox formControlName="addJuteSoPathsHaveEqualHeight">{{ 'TEXTILE_DATA.MACHINE_QUALITY.JUTE_CONDITIONS.JUTE' | bmsTranslate }}</mat-checkbox>
        </div>
      </div>
      <div class="flex-column gap-8">
        <mat-checkbox formControlName="addAdditionalSidePattern">
          {{ 'GENERAL.ACTIONS.ADD' | bmsTranslate }} {{ 'TEXTILE_DATA.MACHINE_QUALITY.JUTE_CONDITIONS.ADDITIONAL_SIDE_PATTERN' | bmsTranslate }}
        </mat-checkbox>
        <mat-checkbox formControlName="addConditionalDesigns"> {{ 'GENERAL.ACTIONS.ADD' | bmsTranslate }} {{ 'TEXTILE_DATA.MACHINE_QUALITY.JUTE_CONDITIONS.TITLE' | bmsTranslate }} </mat-checkbox>
      </div>
    </div>
  </div>
</section>
